import { isNative } from './native';

/**
 * מה האפליקציה חושפת. הוחלט (28.9.2026): שיחות, תבניות (רשימה ושליחה בלבד),
 * אנשי קשר בסיסי, פרופיל והגדרות התראות. כל השאר נשאר בווב.
 */

//* פריטי המגה-מניו (id מתוך src/menu-items/pages.tsx) שמוצגים באפליקציה
export const MOBILE_MENU_IDS = new Set<string>(['contacts', 'templates']);

//* קידומות ראוטים שנטענות באפליקציה; כל ראוט אחר מוסר ומופנה ל-/chats דרך ה-catch-all
const MOBILE_ROUTE_PREFIXES = ['/chats', '/contacts', '/templates', '/customization', '/profile'];

//* תת-ראוטים של תבניות שאין להם מקום באפליקציה (יצירה/עריכה)
const MOBILE_ROUTE_EXCLUDES = ['/templates/create', '/templates/edit', '/templates/drafts/'];

export const isMobileRoutePath = (path: string | undefined): boolean => {
  if (!path) return false;
  if (MOBILE_ROUTE_EXCLUDES.some((p) => path.startsWith(p))) return false;
  return MOBILE_ROUTE_PREFIXES.some((p) => path === p || path.startsWith(p + '/') || path.startsWith(p + '/*'));
};

/** מסנן את children של MainRoutes — בווב מחזיר את הרשימה כמו שהיא */
export const filterRoutesForPlatform = <T extends { path?: string }>(routes: T[]): T[] => {
  if (!isNative) return routes;
  return routes.filter((r) => isMobileRoutePath(r.path));
};

export const MOBILE_HOME_PATH = '/chats';
